// extracted by mini-css-extract-plugin
var _1 = "TaskEdit_field__jO2mI";
export { _1 as "field" }
